import {
  FormdataRevisionCollection as Data,
} from '@/typings/api/Formdata'

import { dateFormatter } from '@/helpers/dateFormatter'
import { VIEW } from '@/helpers/enums/table-actions'


export const TABLE_ACTIONS = Object.freeze([
  VIEW,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Тип',
    value: 'category',
    sortable: false,
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: false,
    width: 154,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value, 'DD.MM.YYYY HH:mm:ss')
    ),
  },
])
